export interface IconProps {
  icon: IconIds;
  width?: number;
  height?: number;
  viewBox?: string;
  className?: string;
}

export type IconIds =
  | 'ActivityZones'
  | 'AIHead'
  | 'Apartment'
  | 'ArrowLeft'
  | 'ArrowLongRight'
  | 'Business'
  | 'Camera'
  | 'Cancel'
  | 'Caret'
  | 'Cart'
  | 'Chat'
  | 'ChatSmall'
  | 'Check'
  | 'CheckCircle'
  | 'CheckCircle2'
  | 'CheckCircle3'
  | 'CheckCircle4'
  | 'ChevronDown'
  | 'FacebookCircle'
  | 'Gift'
  | 'Hamburger'
  | 'Heart'
  | 'Hide'
  | 'House'
  | 'Info'
  | 'InstagramCircle'
  | 'Logo'
  | 'LogoUnderline'
  | 'Minus'
  | 'ModalInfo'
  | 'Money'
  | 'MotionTracking'
  | 'No'
  | 'NoPet'
  | 'Owl'
  | 'Panel'
  | 'Phone'
  | 'PhoneSmall'
  | 'Plus'
  | 'Question'
  | 'Scale'
  | 'ShieldCheck'
  | 'SolarPower'
  | 'Star'
  | 'Ticket'
  | 'User'
  | 'Visible'
  | 'XCircle'
  | 'YesPet'
  | 'YesCheck'
  | 'YoutubeCircle';

export type IconDimensions = {
  width: number;
  height: number;
  viewBox: string;
};

export const iconSizes: Record<IconIds, IconDimensions & { classes?: string }> =
  {
    ActivityZones: {
      width: 24,
      height: 24,
      viewBox: '0 0 24 24'
    },
    AIHead: {
      width: 28,
      height: 31,
      viewBox: '0 0 28 31'
    },
    Apartment: {
      width: 40,
      height: 40,
      viewBox: '0 0 40 40'
    },
    ArrowLeft: {
      width: 19,
      height: 19,
      viewBox: '0 0 19 19'
    },
    ArrowLongRight: {
      width: 25,
      height: 19,
      viewBox: '0 0 25 19'
    },
    Business: {
      width: 40,
      height: 40,
      viewBox: '0 0 40 40'
    },
    Camera: {
      width: 30,
      height: 28,
      viewBox: '0 0 30 28'
    },
    Cancel: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Caret: {
      width: 34,
      height: 34,
      viewBox: '0 0 34 34'
    },
    Cart: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Chat: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36',
      classes: 'chat-mask'
    },
    ChatSmall: {
      width: 14,
      height: 9,
      viewBox: '0 0 14 9'
    },
    Check: {
      width: 19,
      height: 19,
      viewBox: '0 0 19 19'
    },
    CheckCircle: {
      width: 26,
      height: 27,
      viewBox: '0 0 26 27'
    },
    CheckCircle2: {
      width: 30,
      height: 30,
      viewBox: '0 0 30 30'
    },
    CheckCircle3: {
      width: 25,
      height: 25,
      viewBox: '0 0 25 25'
    },
    CheckCircle4: {
      width: 25,
      height: 25,
      viewBox: '0 0 25 25'
    },
    ChevronDown: {
      width: 9,
      height: 5,
      viewBox: '0 0 9 5'
    },
    FacebookCircle: {
      width: 31,
      height: 31,
      viewBox: '0 0 31 31'
    },
    Gift: {
      width: 18,
      height: 18,
      viewBox: '0 0 18 18'
    },
    Hamburger: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Heart: {
      width: 33,
      height: 30,
      viewBox: '0 0 33 30'
    },
    Hide: {
      width: 34,
      height: 34,
      viewBox: '0 0 34 34'
    },
    House: {
      width: 40,
      height: 40,
      viewBox: '0 0 40 40'
    },
    Info: {
      width: 14,
      height: 14,
      viewBox: '0 0 14 14'
    },
    InstagramCircle: {
      width: 31,
      height: 31,
      viewBox: '0 0 31 31'
    },
    Logo: {
      width: 89,
      height: 22,
      viewBox: '0 0 89 22'
    },
    LogoUnderline: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Minus: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    ModalInfo: {
      width: 14,
      height: 14,
      viewBox: '0 0 14 14'
    },
    Money: {
      width: 45,
      height: 27,
      viewBox: '0 0 45 27'
    },
    MotionTracking: {
      width: 29,
      height: 29,
      viewBox: '0 0 29 29'
    },
    No: {
      width: 23,
      height: 23,
      viewBox: '0 0 23 23'
    },
    NoPet: {
      width: 40,
      height: 40,
      viewBox: '0 0 40 40'
    },
    Owl: {
      width: 19,
      height: 32,
      viewBox: '0 0 19 32'
    },
    Panel: {
      width: 43,
      height: 26,
      viewBox: '0 0 43 26'
    },
    Phone: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    PhoneSmall: {
      width: 12,
      height: 13,
      viewBox: '0 0 12 13'
    },
    Plus: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Question: {
      width: 34,
      height: 34,
      viewBox: '0 0 34 34'
    },
    Scale: {
      width: 45,
      height: 45,
      viewBox: '0 0 45 45'
    },
    SolarPower: {
      width: 49,
      height: 49,
      viewBox: '0 0 49 49'
    },
    ShieldCheck: {
      width: 33,
      height: 38,
      viewBox: '0 0 33 38'
    },
    Star: {
      width: 24,
      height: 24,
      viewBox: '0 0 24 24'
    },
    Ticket: {
      width: 34,
      height: 18,
      viewBox: '0 0 34 18'
    },
    User: {
      width: 36,
      height: 36,
      viewBox: '0 0 36 36'
    },
    Visible: {
      width: 34,
      height: 34,
      viewBox: '0 0 34 34'
    },
    YesCheck: {
      width: 23,
      height: 23,
      viewBox: '0 0 23 23'
    },
    XCircle: {
      width: 25,
      height: 25,
      viewBox: '0 0 25 25'
    },
    YesPet: {
      width: 40,
      height: 40,
      viewBox: '0 0 40 40'
    },
    YoutubeCircle: {
      width: 31,
      height: 31,
      viewBox: '0 0 31 31'
    }
  };
